var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reload_svg__clip0_8632_24056)",
    fill: "#FFC834"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.13 4.941a13.43 13.43 0 00-.3 6.42.76.76 0 001.26.33 12.8 12.8 0 015.13-3.76.75.75 0 10-.39-1.45 14.38 14.38 0 00-5.81 4.15l1.26.33a11.88 11.88 0 01.29-5.62.75.75 0 00-1.44-.4zM19.11 18.631a12.3 12.3 0 015.07-2.36l-.85-1.11a14.18 14.18 0 00-1.61 6.67.75.75 0 001.5 0 12.5 12.5 0 011.41-5.91.76.76 0 00-.85-1.1c-2.097.459-4.06 1.4-5.73 2.75a.75.75 0 000 1.06.77.77 0 001.06 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.59 16.061c.52 5 5.19 8.39 10.06 8.48a12.89 12.89 0 006.87-1.71 14.78 14.78 0 005.13-6c.44-.86-.86-1.62-1.3-.76a13.67 13.67 0 01-4.35 5.29 11 11 0 01-5.78 1.65c-4.17.08-8.67-2.5-9.13-7-.1-1-1.6-1-1.5 0v.05zM24.88 9.431a11.69 11.69 0 00-4.72-6.94c-2.54-1.81-5.27-2-8.26-1.51a9.91 9.91 0 00-7.76 4.91 19 19 0 00-1.5 3.54c-.35.9 1.1 1.29 1.44.4a19.16 19.16 0 011.3-3.1 10.56 10.56 0 011.34-1.77 9.14 9.14 0 015-2.42c2.67-.53 5.13-.5 7.45 1.07a10.23 10.23 0 014.29 6.22c.19.94 1.64.55 1.44-.4h-.02z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reload_svg__clip0_8632_24056"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1.58 .751)",
    d: "M0 0h23.32v23.79H0z"
  })))));
}
export default SvgReload;